import { render, staticRenderFns } from "./WebhookDetailDialog.vue?vue&type=template&id=3ef62be5&"
import script from "./WebhookDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./WebhookDetailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports